import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import './Conversations.css';
import airbnb_logo from '../assets/airbnb.png';
import vrbo_logo from '../assets/vrbo.png';
import booking_logo from '../assets/booking.png';

const Conversations = () => {
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    // Fetch existing messages with latest message per conversation
    const fetchMessages = async () => {
      const { data, error } = await supabase.rpc('fetch_conversations_with_latest_message'); // Use RPC function
      if (!error) setConversations(data);
      console.log(data);
      console.log(error);
    };

    fetchMessages();

    // Subscribe to real-time updates
    const channel = supabase
      .channel('realtime:conversations')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'conversations' },
        (payload) => {
          console.log('Change received:', payload);

          if (payload.eventType === 'INSERT') {
            setConversations((prev) => [...prev, payload.new]);
          } else if (payload.eventType === 'DELETE') {
            setConversations((prev) => prev.filter((msg) => msg.id !== payload.old.id));
          } else if (payload.eventType === 'UPDATE') {
            setConversations((prev) =>
              prev.map((msg) => (msg.id === payload.new.id ? payload.new : msg))
            );
          }
        }
      )
      .subscribe();

    // Cleanup subscription on unmount
    return () => {
      supabase.removeChannel(channel);
    };
  }, []);


  function formatDate(date) {
    const now = new Date();
    const inputDate = new Date(date);

    const isToday = now.toDateString() === inputDate.toDateString();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = yesterday.toDateString() === inputDate.toDateString();

    const daysAgo = Math.floor((now - inputDate) / (1000 * 60 * 60 * 24));

    if (isToday) {
        // Format as "8:49PM"
        return inputDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } else if (isYesterday) {
        return "Yesterday";
    } else if (daysAgo <= 6) {
        // If within the last 6 days, show the day of the week
        return inputDate.toLocaleDateString('en-US', { weekday: 'long' });
    } else {
        // More than 6 days ago, show "1/20" format
        return inputDate.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric' });
    }
}

function formatReservationDates(arrivalDate, departureDate) {
  const arrival = new Date(arrivalDate);
  const departure = new Date(departureDate);

  const options = { month: 'short', day: 'numeric' };

  if (arrival.getMonth() === departure.getMonth() && arrival.getFullYear() === departure.getFullYear()) {
      // Same month: "Feb 1 - 2"
      return `${arrival.toLocaleDateString('en-US', options)} - ${departure.getDate()}`;
  } else {
      // Different months: "Jan 30 - Feb 2"
      return `${arrival.toLocaleDateString('en-US', options)} - ${departure.toLocaleDateString('en-US', options)}`;
  }
}



function getChannelImages (channelName) {
  switch (channelName) {
    case 'airbnbOfficial':
      return airbnb_logo;
    case 'vrboOfficial':
      return vrbo_logo;
    case 'homeaway':
      return vrbo_logo;
    case 'bookingcom':
      return booking_logo;
    default:
      return '';
  }
}



  return (
    <div className='MessagesContainer'>
        {conversations.map((x) => (
          <div key={x.id} className='MessageCard' onClick={() => window.location.href = `/conversations/${x.id}`}>
            <div className='MessageCardLeft'> 
              <div className='MessageCardListingImageContainer'>
                <img src={x.guest_picture} className='MessageCardListingImage'/> {/* LISTING IMAGE PLACEHOLDER */}
                <div className='MessageCardPlatformLogoContainer'>
                  <img src={getChannelImages(x.channel_name)} className='MessageCardPlatformLogo' />
                </div>
              </div>
            </div>

            <div className='MessageCardRight'>
              <strong className='MessageCardRightGuestName'>{x.recipient_name}</strong> 
              <span className='MessageCardRightMessagePreview'>{x.body} </span>
              <span className='MessageCardRightMessageDate'>{formatDate(x.date)}</span>
              <div className='MessageCardRightMessageReservationDates'>{formatReservationDates(x.arrival_date, x.departure_date)}</div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Conversations;
